import { MyNaviTypography } from '@/components/Campaign/mynavi/MyNaviUI/MyNaviTypography'
import { MyNaviWishButton } from '@/components/Campaign/mynavi/MyNaviWishButton/MyNaviWishButton'
import type { MynaviOpenCampusItem } from '@/schemas/v2/mynavi'

export type MyNaviOpenCampusItemProps = {
  oc: MynaviOpenCampusItem
  isWished: boolean
  onToggleWanted: () => void
  /** undefined の場合はボタンを disabled にする */
  onViewDetail?: () => void
}

export const formatEventDate = (eventDate: string | null): { year: string; monthDay: string } => {
  if (!eventDate) return { year: '', monthDay: '' }
  const [y, m, d] = eventDate.split('-').map(Number)
  const date = new Date(y, m - 1, d)
  const year = `${date.getFullYear()}年`
  const weekDays = ['日', '月', '火', '水', '木', '金', '土']
  const monthDay = `${date.getMonth() + 1}/${date.getDate()}(${weekDays[date.getDay()]})`
  return { year, monthDay }
}

export const MyNaviOpenCampusItem = ({ oc, isWished, onToggleWanted, onViewDetail }: MyNaviOpenCampusItemProps) => {
  const { year, monthDay } = formatEventDate(oc.eventDate)

  return (
    <div className="py-2">
      {/* 開催日枠 */}
      <div
        className="relative border border-[#686868] rounded-[5px] mx-4 px-3 pt-4 pb-[21px] bg-[#fbfbfb]"
        style={{ minHeight: '92px' }}
      >
        {/* 行きたいボタン（右上） */}
        <div className="absolute top-[11px] right-[18px]">
          <MyNaviWishButton isWished={isWished} onClick={onToggleWanted} />
        </div>

        {/* 年 */}
        {year && (
          <MyNaviTypography variant="micro" as="p" className="leading-none">
            {year}
          </MyNaviTypography>
        )}

        {/* 月日 + 時間 */}
        <div className="flex items-center gap-4 mt-[10px]">
          {monthDay && (
            <MyNaviTypography variant="caption" as="p" className="leading-none">
              {monthDay}
            </MyNaviTypography>
          )}
          {oc.eventTime && (
            <MyNaviTypography variant="caption" as="p" className="leading-none">
              {oc.eventTime}
            </MyNaviTypography>
          )}
        </div>

        {/* キャンパス名 */}
        {oc.location && (
          <MyNaviTypography variant="caption" as="p" className="mt-[13px] leading-none">
            {oc.location}
          </MyNaviTypography>
        )}
      </div>

      {/* 詳細を見る・予約するボタン */}
      {onViewDetail && (
        <div className="px-4 mt-[13px]">
          <button
            type="button"
            onClick={onViewDetail}
            disabled={!onViewDetail}
            className="w-full h-[33px] rounded-[5px] bg-[#058bbe] text-white text-[12px] disabled:opacity-40"
            style={{ fontFamily: "'BIZ UDPGothic', sans-serif", fontWeight: 700 }}
          >
            詳細を見る・予約する
          </button>
        </div>
      )}
    </div>
  )
}
